import React from 'react';
import PropTypes from 'prop-types';
import successIcon from 'assets/img/image-feedback-success.png';
import StepProgress from './StepProgress';

export default function FeedbackSuccessModal({ onClose }) {
  return (
    <>
      <div className="modal-body" style={{ padding: 22 }}>
        <div className="d-flex flex-column align-items-center text-center px-3 py-2">
          <div className="w-100" style={{ maxWidth: 640 }}>
            <StepProgress step={3} />
          </div>
          <img src={successIcon} alt="" width={92} height={92} />

          <div className="font-weight-bold mt-4" style={{ fontSize: 28, lineHeight: 1.15 }}>
            Submission Successful!
            <br />
            Your Voice Matters.
          </div>

          <div className="text-muted mt-3" style={{ maxWidth: 520, fontSize: 14, lineHeight: 1.65 }}>
            Your feedback has been recorded and will be kept confidential. This data is vital for
            our office to comply with the ARTA mandates and evaluate the quality of our public
            services. Because of your input, we can take concrete steps to make future government
            transactions easier, faster, and more transparent. Thank you once again for
            contributing to better governance.
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-block btn-link text-dark"
          style={{ fontWeight: 600, textDecoration: 'none' }}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </>
  );
}

FeedbackSuccessModal.propTypes = {
  onClose: PropTypes.instanceOf(Function).isRequired,
};
